import React, { useEffect, useState } from "react";
import { SearchBox } from "./features/SearchBox";
import { Cards } from "./features/Cards";
import { Button } from "./features/Button";
import { Modal } from "./features/Modal";
import { ICocktails, IDrinkProps, IEventProps } from "./interfaces/Interfaces";
import dots from "./icons/dots.svg";

function App() {
  //Contains the searchbox's input value
  const [search, setSearch] = useState("");

  //Declare's a state to hold the data from the API
  const [data, setData] = useState([] as ICocktails[]);

  //Controls visibility of error message for input validation
  const [error, setError] = useState(false);

  //Controls visibility of directions and receipe modal popup
  const [modal, setModal] = useState(false);

  //Keeps track of which drink is selected in order to display the correct information and how-to-make instructions in the modal pop-up
  const [drink, setDrink] = useState({});

  //Combines the exact measurements with the ingredients to create the exact receipe for display in the modal-pop
  const [exactRecipe, setExactRecipe] = useState<(string | undefined)[]>([]);

  //Displays a loading icon when the data is being loaded after a search is performed
  const [loadingResults, setLoadingResults] = useState(true);

  //Displays a loading icon when the recipe and directions are being loaded after a drink is chosen
  const [loadingRecipe, setLoadingRecipe] = useState(true);

  //Controls placement of the searchbar if a search is in progress or not
  const [userSearch, setUserSearch] = useState(false);

  //Async await using the fetch API to fetch the cocktail data from TheCocktaiLDB's free API
  let cocktails = async () => {
    //Fetch the data
    const response = await fetch(
      `https://www.thecocktaildb.com/api/json/v1/1/search.php?s=${search}`
    );

    //Set results to the JSON data received from the API
    const results = await response.json();

    //If the HTTP request response is bad displays an error and resets the searchbox
    if (response.status >= 400) {
      setUserSearch(false);
      setSearch("");
      setError(true);
    } else if (results.drinks === null) {
      setError(true);
      setSearch("");
      debugger;
      setTimeout(() => setError(false), 4000);
    } else {
      //If everything is successful the data state is set to the JSON state and the searchbox is cleared
      setData(results.drinks);
      setSearch("");
      setLoadingResults(false);
      setUserSearch(true);
      setTimeout(() => {
        setLoadingResults(true);
      }, 1500);
    }
  };

  //Clears the searchbox input and sets the data back to an empty array
  const clearHandler = () => {
    setSearch("");
    setData([]);
    setError(false);
    setLoadingResults(true);
    setUserSearch(false);
  };

  //Regex to check for any numbers inputted to the search box
  const searchValidation: RegExp = /\d+/;

  //Tests user input against the regex as well as for no text or blank empty space to control the component
  const searchHandler = () => {
    if (
      searchValidation.test(search) === true ||
      search === "" ||
      search === " "
    ) {
      setError(true);
      setTimeout(() => setError(false), 4000);
    } else {
      cocktails();
    }
  };

  //Empty array to hold the recipe pushed by the getRecipe function below
  const filteredRecipe: (string | undefined)[] = [];

  const getRecipe = (drink: IDrinkProps) => {
    /*Each drink object has the properties strIngredient1 through 15 as well as strMeasure1 through 15
   this checks each property to determine if it's a string and checks that it's not an empty string, if it passes
   those two conditions then it is pushed to the filteredRecipe array and displayed in the modal popup for the drink the user selects.*/

    for (let i = 0; i <= 14; i++) {
      /*Checks that the current ingredient is a string, if not no action is taken.  Only hte ingredient is checked as the 
      ingredient number matches the measurement number in all drinks*/

      if (typeof drink[`strIngredient${i}`] !== "string") {
        //Checks if the current ingredient is an empty string if so no action
      } else if (drink[`strIngredient${i}`] === "") {
      } else {
        //If the checks above pass the ingredient and measurement is pushed to the filteredRecipe array

        filteredRecipe.push(
          `${drink[`strIngredient${i}`]} ${drink[`strMeasure${i}`]}`
        );
      }
      //Once the for loop finishes the filteredRecipe array is set to the ingrdients state and displayed in the modal pop-up
      setExactRecipe(filteredRecipe);
    }
  };

  //Runs the ingredient and measurements finder again each time a new drink is assigned to the drink state
  useEffect(() => {
    if (drink.hasOwnProperty("strDrink")) {
      getRecipe(drink);
    }
  }, [drink]);

  //Handles key presses inside the searchbox component to trigger the submit and clear functiosn via the Enter and Escape keys.
  const handleKeyDown = (event: IEventProps) => {
    if (event.key === "Enter") {
      searchHandler();
    } else if (event.key === "Escape") {
      clearHandler();
    }
  };

  //
  return (
    <div className="box-border m-0 p-0 text-paratone bg-highlight min-h-screen">
      <header
        className={
          userSearch
            ? "flex flex-col justify-center items-center flex-wrap max-w-full lg:flex-row 2xl:flew-row animate-fadeIn"
            : "flex flex-col justify-center items-center flex-wrap max-w-full lg:flex-row 2xl:flew-row h-screen animate-fadeIn"
        }
      >
        <SearchBox
          search={search}
          setSearch={setSearch}
          error={error}
          handleKeyDown={handleKeyDown}
        />
        <Button
          title="Submit"
          onClick={() => {
            searchHandler();
          }}
        />
        <Button
          title="Clear"
          onClick={() => {
            clearHandler();
          }}
        />
      </header>

      {
        //The modal is only displayed when the user clicks on recipe & directions
        modal ? (
          <Modal
            drink={drink}
            setModal={setModal}
            modal={modal}
            recipe={exactRecipe}
            loadingRecipe={loadingRecipe}
            setLoadingRecipe={setLoadingRecipe}
          />
        ) : (
          ""
        )
      }
      <div className="flex justify-center items-center p-3 h-full flex-grow bg-highlight animate-fadein">
        <div>
          {
            //If no search has been performed display the header below
            loadingResults === false ? (
              <div className="flex justify-center items-center h-screen w-full">
                <img src={dots} alt="loading animation" />
              </div>
            ) : (
              <Cards
                data={data}
                modal={modal}
                setModal={setModal}
                setDrink={setDrink}
                setLoadingRecipe={setLoadingRecipe}
              />
            )
          }
        </div>
      </div>
    </div>
  );
}

export default App;
